import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { DatacenterType } from '../../../../shared/models/datacenter-aggrid-view';
import { ORDER_NUMBER_OPTIONS } from '../../../../shared/models/list';
import { UNDERSCORE } from '../../../../shared/utils/constant';
import { Document, DocumentLine } from '../../../models/document';
import { DocumentService } from '../../../services/documents.service';
import { SafeUrlPipe } from '../../../../shared/pipes/safeurl.pipe';
import { DatePipe } from '../../../../shared/pipes/date.pipe';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-certificate',
	templateUrl: './certificate.component.html',
	styleUrl: '../commercial-documents-list.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatIconModule,
		TranslateModule,
		RouterLink,
		MatRippleModule,

		MatButtonModule,
		NgFor,
		LoadingSpinnerComponent,
		DatePipe,
		SafeUrlPipe
	]
})
export class CertificateComponent {
	@Input() document?: Document;
	@Input() orderDisplay?: keyof typeof ORDER_NUMBER_OPTIONS;
	@Output() readonly createFilter = new EventEmitter<{ document: Document; filterType: DatacenterType }>();
	readonly UNDERSCORE = UNDERSCORE;

	constructor(
		private readonly documentService: DocumentService
	) {}

	getOrderName(documentLine: DocumentLine, type: string) {
		switch (type) {
		case 'customer': if (this.document?.customerOrderReference && documentLine.customerOrderItemReference) {
			return `${ this.document.customerOrderReference }/${ documentLine.customerOrderItemReference }`;
		} else if (this.document?.customerOrderReference && !documentLine.customerOrderItemReference) {
			return this.document.customerOrderReference;
		}
			break;
		case 'supplier': if (this.document?.supplierOrderReference && documentLine.supplierOrderReferenceItem) {
			return `${ this.document.supplierOrderReference }/${ documentLine.supplierOrderReferenceItem }`;
		} else if (this.document?.supplierOrderReference && !documentLine.supplierOrderReferenceItem) {
			return this.document.supplierOrderReference;
		}
			break;
		}
		return UNDERSCORE;
	}

	downloadDocument(id: number, filename: string) {
		return this.documentService.getDownloadDocumentUrl(id, filename);
	}

	getDocumentURL(id: number, filename: string) {
		return this.documentService.getViewDocumentUrl(id, filename);
	}

	callFilter(document: Document, filterType: DatacenterType) {
		this.createFilter.emit({ document, filterType });
	}
}
